import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg";
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg";
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg";
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg";

import FileUploadComponent from "../fileUpload/FileUploadComponent.js";
import OverviewRightPanel from "../panels/OverviewRightPanel";
import "../../styling/ClientPortal.css";
import { useContext } from "react";
import { EventDataContext } from "../EventDataContext";

const OverviewTabBusiness = ({ brandingColours }) => {
  const { EventData, setEventData } = useContext(EventDataContext);

  let coverPic = otherPhoto;
  if (EventData.eventType == "corporate") {
    coverPic = businessPhoto;
  } else if (EventData.eventType == "birthday") {
    coverPic = birthdayPhoto;
  } else if (EventData.eventType == "wedding") coverPic = weddingPhoto;


  const eventDate = new Date(EventData.eventDate);
  const startTime = new Date(EventData.startTime);
  const endTime = new Date(EventData.endTime);


  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, 
  };


  return (
    <div className="event-overview-container" style={{ width: "100%" }}>
    <div className="event-overview-container-main">
     {/* Banner Section with Blur and Gradient */}
     <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000' }}>
        {/* 1. The Base Image */}
        <img
          src={coverPic}
          alt="cover"
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "cover",
            objectPosition: "top" 
          }}
          className="overviewClientLeftPanelImage"
          onError={(e) => { e.target.src = otherPhoto; }}
        />

        {/* 2. The Blur Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
          WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
        }} />
        
        {/* 3. The Bottom Gradient & Text Overlay */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
          color: 'white',
          padding: '20px',
          boxSizing: 'border-box'
        }}>
          <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
            {EventData.eventName || "Untitled Event"}
          </h1>
          <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
            Date Booked: {eventDate.toLocaleDateString()}
          </p>
        </div>
      </div>
      <div className="event-overview-content-container">
      <div
        style={{fontWeight: "300", padding:'20px' }}
        className="event-overview-div"
      >
        <h2 style={{ color: "#000000", fontWeight: "500" }}>Event Overview</h2>
        <p style={{ width: "100%" }}>{EventData?.details}</p>
      </div>

      <div
        style={{fontWeight: "300", color: "#000000", padding: '20px' }}
        className="event-overview-div"
      >
        <h2 style={{ fontWeight: "500" }}>Event Details</h2>
        <h4 style={{ fontWeight: "500", marginBottom: "-5px" }}>Date</h4>
        <p style={{ color: "#625C73" }}>{eventDate.toLocaleDateString()}</p>
        <h4 style={{ fontWeight: "500", marginBottom: "-5px" }}>Time</h4>
        <p style={{ color: "#625C73" }}>
          {startTime.toLocaleTimeString("en-US", optionsTime) +
            " - " +
            endTime.toLocaleTimeString("en-US", optionsTime)}
        </p>
        <h4 style={{ fontWeight: "500", marginBottom: "-5px" }}>Location</h4>
        <p style={{ color: "#625C73" }}>{EventData?.address}</p>
      </div>
      <div className="event-overview-div">
        <h2 style={{ fontWeight: "500", color: "#000000", marginTop: "30px", padding: '20px', paddingBottom: "0px", marginBottom: "0px" }}>
          Documents &amp; Files
        </h2>

        <div style={{width:'90%', padding: '20px'}}>
            <FileUploadComponent

          brandingColours={brandingColours}
          eventId={EventData._id}
          user="business"
        />
        </div>
      </div>
      </div>
      </div>
      <div className="overviewBusinessRightPanel">
        <OverviewRightPanel brandingColours={brandingColours} />
      </div>
    
    </div>
    
   
  );
};

export default OverviewTabBusiness;
